/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { ButtonLink } from "components/styles";
import { requestGetChangeHistoryStudentPenalty } from "services/settings/penaltyAdmin/dataAboutPenaltyAdmin";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import DialogChangeHistory from "./DialogChangeHistory/DialogChangeHistory";

const ChangeHistory = ({
    loadingRequest,
    form, student
}) => {
    const [changeHistory, setChangeHistory] = useState([]);
    const dialog = useShowDialogAlert();
    useEffect(() => {
        if (dialog.value)
            fillChangeHistory();
    }, [dialog.value]);
    async function fillChangeHistory() {
        loadingRequest.show("Cargando historial...");
        const data = await requestGetChangeHistoryStudentPenalty(form.id);
        loadingRequest.hide();
        setChangeHistory(data);
    }
    return (
        <>
        <ButtonLink onClick={() => dialog.open()}>Ver historial de cambios</ButtonLink>
        <DialogChangeHistory 
            dialog={dialog}
            changeHistory={changeHistory}
            data={{
                student: student, 
                form
            }}/>
        </>
    );
}

export default ChangeHistory;